<template>
  <section class="app-container">
    <invoice-title :titleType="formData.titleType" :titleList='titleList' :defaultVal='defaultVal'
      :parkId='pendingBill[0].parkId' />
    <van-form validate-first @submit="onSubmit" @failed="onFailed" class="invoice">
      <van-field name="titleType" label="抬头类型">
        <template #input>
          <van-radio-group @change="change" v-model="formData.titleType" direction="horizontal">
            <van-radio icon-size="14px" name="1">
              公司抬头
            </van-radio>
            <van-radio icon-size="14px" name="2">
              个人/非企业抬头
            </van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <smartinput v-if="formData.titleType=='1'" v-bind="provinceList" @collect="collectProvince "
        :company='formData.company' @searchtxt="getinvoice">
      </smartinput>
      <van-field required v-model="formData.company" v-else name="company" label="发票抬头" placeholder="请输入发票抬头" />
      <van-field required v-model="formData.gmf_nsrsbh" v-if="formData.titleType=='1'" name="gmf_nsrsbh"
        :rules="taxRules" placeholder="请输入纳税人识别号" label="发票税号" />
      <van-field required v-model="formData.email" name="email" :rules="emailRules" placeholder="请输入电子邮箱"
        label="电子邮箱" />
      <van-field required v-model="formData.phone" name="phone" :rules="phoneRules" placeholder="请输入手机号码"
        label="手机号码" />
      <van-field v-model="formData.type" name="type" label="发票内容" readonly />
      <van-field v-model="formData.money" name="money" label="发票金额" readonly />
      <van-cell class="invoice__otherInfo" title="更多信息" v-if="formData.titleType=='1'" value="填写备注、地址等(非必填)" is-link
        @click="editOtherInfo" />
      <!-- 更多信息弹出框 -->
      <van-popup v-model="showOtherInfo" closeable round class="bottom_popup_box" position="bottom">
        <div class="bottom_popup_box_menu">
          <van-field v-model="formData.remark" name="remark" label="备注说明" placeholder="请填写备注说明" />
          <van-field v-model="formData.address" name="address" label="地址及电话" placeholder="请填写注册地址及电话" />
          <van-field v-model="formData.bank" name="bank" label="开户行及账号" placeholder="请填写开户行及银行账号" />
          <div class="btn_box">
            <van-button size="large" class="blue-btn" @click="updateInvoiceAndUserRel">
              确定
            </van-button>
          </div>
        </div>
      </van-popup>
      <div class="btn_box bottom">
        <van-button native-type="submit" size="large" class="blue-btn" @click="submitInvoice">
          立即提交
        </van-button>
      </div>
    </van-form>
  </section>
</template>

<script>
import {
  Form,
  Field,
  CellGroup,
  RadioGroup,
  Radio,
  Dialog,
  Popup,
  Notify
} from 'vant'
import smartinput from '@/components/SmartInput/index'
import config from '@/config/index'
import InvoiceTitle from './components/InvoiceTitle'
import { parseTime } from '@/utils'
import { mapGetters } from 'vuex'
import { getInvoiceTitleInfoByBW, getBillingInformation, getInvoiceTitleInfo, invoicing } from '@/api/invoice'
export default {
  name: 'Invoice-Form',
  computed: {
    ...mapGetters([
      'pendingBill',//发票订单
      'infoAsUserInvoice',//当前用户发票抬头
      'invoiceInfo',//发票信息
      'invoiceToken',//发票token
    ])
  },
  watch: {
    infoAsUserInvoice: function (newVal, oldVal) {
      if (newVal == oldVal) {
        return
      }
      this.formData.id = newVal.id
      this.formData.company = newVal.company
      this.formData.gmf_nsrsbh = newVal.gmf_nsrsbh
      this.formData.email = newVal.email
      this.formData.titleType = newVal.titleType
      this.formData.phone = newVal.phone
    }
  },
  components: {
    smartinput,
    InvoiceTitle,//用户抬头信息
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.Component.name]: Dialog.Component,
    [Popup.name]: Popup,
    [Notify.name]: Notify,
  },
  data () {
    this.phoneRules = [
      { required: true, message: '请输入手机号码' },
      { validator: this.phoneValidator, message: '手机号码格式错误' },
    ];
    this.emailRules = [
      { required: true, message: '请输入邮箱' },
      { validator: this.emailValidator, message: '邮箱格式错误' },
    ];
    this.taxRules = [
      { required: true, message: '请输入税号' },
      { validator: this.taxValidator, message: '纳税人识别号格式错误' },
    ];
    return {
      provinceList: {
        list: []
      },
      config,
      pttitleList: [],//票通模糊列表
      titleList: [],
      defaultVal: {},
      showOtherInfo: false,
      formData: {
        titleType: '',//抬头类型（非参数）
        access_token: null,
        company: "", //如果是个人为个人姓名 是企业就是企业名
        money: 0,
        type: "停车费",
        address: "",
        gmf_nsrsbh: "",
        nsrsbh: '',
        email: "",
        bank: "",
        recipient: "",
        phone: "",
        order_num: "",
        remark: ""//备注
      }
    }
  },
  mounted () {
    this.initFormData()
    this.getInoiceList(1)
  },

  methods: {
    // 获取票通抬头
    getinvoice (item) {
      if (this.config.projectName == 'NJNZ') {
        let params = {
          access_token: this.invoiceToken, //鉴权
          parkId: this.pendingBill[0].parkId,
          companyName: item
        }
        getInvoiceTitleInfoByBW(params).then(res => {
          this.pttitleList = res.body || []
          this.provinceList.list = []
          this.pttitleList.forEach(item => {
            this.provinceList.list.push(item.enterpriseName)
          })
        }).catch(err => {
          this.$notify({
            type: 'danger',
            message: err
          })
        })
      } else if (this.config.projectName == 'CTC') {
        let params = {
          parkId: this.pendingBill[0].parkId,
          enterpriseName: item
        }
        getInvoiceTitleInfo(params).then(res => {
          this.pttitleList = res.body || []
          this.provinceList.list = []
          this.pttitleList.forEach(item => {
            this.provinceList.list.push(item.enterpriseName)
          })
        }).catch(err => {
          this.$notify({
            type: 'danger',
            message: err
          })
        })
      }

    },
    // 跟智能输入框同步选中的业务
    collectProvince (data) {
      this.formData.company = data
      if (this.config.projectName == 'CTC' || this.config.projectName == 'NJNZ') {
        this.pttitleList.forEach(item => {
          if (item.enterpriseName == data) {
            this.formData.gmf_nsrsbh = item.taxpayerNum
          }
        })      }
    },
    // 校验函数返回 true 表示校验通过，false 表示不通过
    emailValidator (val) {
      return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(val);
    },
    phoneValidator (val) {
      return /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(val);
    },
    taxValidator (val) {
      return /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(val);
    },
    // 获取抬头信息
    getInoiceList (item) {
      // 获取抬头信息
      getBillingInformation().then(res => {
        this.titleList = res.body
        if (item == 1) {
          this.formData.titleType = '1'
        }
      }).catch(err => {
        this.$notify({
          type: 'danger',
          message: err
        })
      })
    },
    change () {

    },
    // 开票后跳转
    InoviceGoWhere (item, status, msg) {
      if (item == 1001 && status == 'wait') {
        this.$notify({
          type: 'success',
          message: '开票中,请稍后前往缴费记录查看。'
        })
        this.$router.push({ name: 'Invoice-Result', query: { result: 'wait' } })
      } else if (item == 1001 && status == 'success') {
        this.$notify({
          type: 'success',
          message: '开票成功，请注意查看邮箱。'
        })
        this.$router.push({ name: 'Invoice-Result', query: { result: 'success' } })
      } else {
        this.$notify({
          type: 'danger',
          message: '开票失败，请联系管理员。' + msg
        })
        this.$router.push({ name: 'Invoice-Result', query: { result: 'fail' } })
      }
      this.getInfo_Loading.clear()
    },
    // 聚合开票
    Invoice () {
      let chargeId = this.pendingBill.map(item => item.platformId)
      let outTradeNo = this.pendingBill.map(item => item.outTradeNo)
      this.formData.order_num = parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') + "_" + Math.random().toString(36).substr(2, 4)
      this.getInfo_Loading = this.$toast.loading('加载中...')
      let params = {
        invoiceMerchant: this.invoiceInfo.invoiceMerchant,
        isRoadsideOrParking: 2,
        list: this.pendingBill,
        parkId: this.pendingBill[0].parkId,
        openid: this.pendingBill[0].openid,
        phone: this.formData.phone,
        email: this.formData.email,
        platformId: chargeId.toString(),
        buyerMC: this.formData.company,//购买方名称
        buyerNSRSBH: this.formData.gmf_nsrsbh,//购买方纳税人识别号
        buyerDZ: this.formData.address,
        buyerDH: this.formData.telephone,
        buyerKHH: this.formData.bank,
        buyerZH: this.formData.account,
        remark: this.formData.remark,
        // kce: ,
        // fpqqlsh:,
        cardNumber: this.pendingBill[0].cardNumber,
        outTradeNo: outTradeNo.toString(),
        handleAmount: this.formData.money,//项目金额 注意：金额是含税，单位：元（2位小数）
        // discountAmount: 0,
        paidMoney: (this.formData.money) * 100,//项目金额 注意：金额是含税，单位：元（2位小数）
      }
      invoicing(params).then(res => {
        this.InoviceGoWhere(res.status, 'success')
      }).catch(err => {
        this.$notify({
          type: 'danger',
          message: '开票失败，请联系管理员。' + err
        })
        this.getInfo_Loading.clear()
        this.$router.push({ name: 'Invoice-Result', query: { result: 'fail' } })
      })
    },
    // 提交发票信息
    submitInvoice () {
      let _this = this
      if (this.formData.titleType == 1) {
        if (this.taxValidator(this.formData.gmf_nsrsbh) == false || this.formData.email == '' || this.emailValidator(this.formData.email) == false || this.formData.company == '' || this.phoneValidator(this.formData.phone) == false) {
          Notify({ type: 'danger', message: '请完善信息[GCEP]' });
          return
        }
      } else {
        if (this.formData.company == '' || this.formData.email == '' || this.emailValidator(this.formData.email) == false || this.phoneValidator(this.formData.phone) == false) {
          Notify({ type: 'danger', message: '请完善信息[CEP]' });
          return
        }
      }
      console.log(_this.invoiceInfo)
      _this.Invoice()
    },
    // 初始化表单数据
    initFormData () {
      let _this = this;
      console.log(this.pendingBill)
      if (!this.pendingBill || this.pendingBill.length === 0) {
        Dialog.alert({
          title: '数据过期失效',
          message: `请返回订单页面并重新选择`,
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonColor: '#1989fa',
          confirmButtonText: '立即选择',
          cancelButtonText: '返回主页'
        })
          .then(() => {
            // on close
            _this.$router.push({
              name: 'Invoice-Temporary'
            })
          })
          .catch(() => {
            _this.$router.push({
              name: 'Personal-Center'
            })
          })
        return
      }
      let billPrice = 0
      for (let item of this.pendingBill) {
        billPrice += Number(item.chargeMoney)
      }


      this.formData.money = billPrice.toFixed(2)
    },
    // 编辑更多信息
    editOtherInfo () {
      this.showOtherInfo = true
    },
    updateInvoiceAndUserRel () {
      this.showOtherInfo = false
    },
    onSubmit (values) {
      console.log('submit', values);
    },
    onFailed (errorInfo) {
      console.log('failed', errorInfo);
    },
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  height: 100vh;
  background-color: #f5f5f5;
  .invoice {
    &__otherInfo {
      /deep/ .van-cell__title,
      .van-cell__value {
        min-width: max-content;
      }
    }
  }
  .bottom_popup_box {
    height: 250px;
    display: flex;
    justify-content: flex-end; //space-evenly
    align-items: center;
    flex-direction: column;
    .bottom_popup_box_menu {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      height: 225px;
    }
  }
  .btn_box {
    width: calc(100vw - 30px);
    max-width: 600px;
  }
  .bottom {
    margin: 20px auto 20px;
  }
}
</style>